
















  import { Vue, Component } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'

  const cms = namespace('cms')

  @Component
  export default class OneCookieBanner extends Vue {
    @cms.Getter configuration: any

    isOpen: boolean = false

    get isPlatformClosed(): boolean {
      return !this.$tenantConfig.isPlatformClosed || this.$auth.isAuthenticated
    }

    get cookieMessage() {
      return this.configuration && this.configuration.cookieAcceptMessage
    }

    created() {
      if (!this.getGDPR()) {
        this.isOpen = true
      }
    }

    getGDPR(): boolean | null | string {
      if (process.client) {
        return localStorage.getItem('cookieNoticeAccepted')
      }
      return null
    }

    accept() {
      if (process.client) {
        this.isOpen = false
        // @ts-ignore
        localStorage.setItem('cookieNoticeAccepted', true)
      }
    }
  }
